import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap"

//redux
import { useSelector } from "react-redux"

import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import ChangePassword from "./Changepassword"
import PasswordIcon from '../../assets/images/passIcon.png'
const UserProfile = () => {
  //meta title
  document.title = "Profile | TenderSoftware - Flexi TracBoard"

  const { profile, accessgroupname } = useSelector(state => ({
    profile: state.Login?.usersDetails?.data,
    accessgroupname:
      state?.Login?.usersDetails?.data?.accessgroupname !== "CategoryUser",
  }))

  const [modal, setModal] = useState(false)
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      firstname:
        (profile && accessgroupname
          ? profile?.firstname
          : profile?.firstName) || "",
      lastname:
        (profile && accessgroupname ? profile?.lastname : profile?.lastName) ||
        "",
      email: (profile && profile?.email) || "",
      contactnumber: (profile && profile?.contactnumber) || "",
      userid: (profile && profile?.userIdentificationNumber) || "",
      role: (profile && profile?.accessgroupname) || "",
      username: (profile && profile?.user_name) || "",
    },
  })
  const handlechangepassword = () => {
    toggle()
  }
  const handleCancel = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="TenderSoftware"
            breadcrumbItem="My Profile"
            className="d-flex justify-content-center"
          />
          <Row className="d-flex justify-content-center">
            <Col xl="4">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4 d-flex justify-content-center">
                    Personal Detail
                  </h4>
                  <Row>
                    <table className="table table-striped">
                      <tbody>
                        {accessgroupname && (
                          <tr>
                            <th scope="row" className="text-uppercase">
                              User Id
                            </th>
                            <td>{validation.values.userid}</td>
                          </tr>
                        )}
                        <tr>
                          <th scope="row" className="text-uppercase">
                            First Name
                          </th>

                          <td>{validation.values.firstname}</td>
                        </tr>
                        <tr>
                          <th scope="row" className="text-uppercase">
                            Last Name
                          </th>
                          <td> {validation.values.lastname}</td>
                        </tr>
                        {accessgroupname && (
                          <tr>
                            <th scope="row" className="text-uppercase">
                              Username
                            </th>
                            <td> {validation.values.username}</td>
                          </tr>
                        )}
                        <tr>
                          <th scope="row" className="text-uppercase">
                            Email
                          </th>
                          <td> {validation.values.email}</td>
                        </tr>
                        {accessgroupname && (
                          <>
                            <tr>
                              <th scope="row" className="text-uppercase">
                                Contact Number
                              </th>
                              <td> {validation.values.contactnumber}</td>
                            </tr>
                            <tr>
                              <th scope="row" className="text-uppercase">
                                Role
                              </th>
                              <td> {validation.values.role}</td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </Row>
                  <div className="d-flex justify-content-center">
                    <h4
                      onClick={handlechangepassword}
                      className="card-title mb-4 mt-1 change-password-hover"
                    >
                      Change Password ?
                    </h4>
                    <img src={PasswordIcon} width={30} height={30} style={{     filter: 'sepia(64%) hue-rotate(197deg) saturate(852%)' }}/>
                  </div>

                  {modal && (
                    <Modal isOpen={modal} toggle={toggle} size="md">
                      <ModalHeader toggle={toggle} tag="h4">
                        {"Change Your Password"}
                      </ModalHeader>
                      <ModalBody>
                        <ChangePassword
                          email={profile?.email}
                          handleCancel={handleCancel}
                          toggle={toggle}
                        />
                      </ModalBody>
                    </Modal>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
